import {AttrsSchema, Component} from 'panel';
import moment from 'moment';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';
import css from './index.inline.styl';

export interface LastUpdatedAttrs {
  'is-compact'?: boolean;
  'last-refresh-date'?: string;
  'preface-text'?: string;
  'refresh-interval-ms'?: number;
}

export interface LastUpdatedProps {
  attrs?: LastUpdatedAttrs;
}

export class LastUpdated extends Component<EmptyObj, LastUpdatedAttrs> {
  private _starter = null;
  private _timer = null;
  private _renderTimer = null;
  static get attrsSchema(): AttrsSchema<LastUpdatedAttrs> {
    return {
      ...super.attrsSchema,
      'is-compact': `boolean`,
      'last-refresh-date': {type: `string`, default: new Date().toISOString()},
      'preface-text': `string`,
      'refresh-interval-ms': {type: `number`, default: null},
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      helpers: {
        getLastRefreshRelativeFormat: () => moment(this.attr(`last-refresh-date`)).fromNow(),
      },
    };
  }

  attributeChangedCallback(attr, oldVal, newVal) {
    super.attributeChangedCallback(attr, oldVal, newVal);
    switch (attr) {
      case `last-refresh-date`:
        this.updateInterval();
        this.update();
        break;
      case `refresh-interval-ms`:
        this.updateInterval();
        break;
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.updateInterval();
    this._renderTimer = setInterval(() => this.update(), 30 * 1000);
  }

  disconnectedCallback() {
    clearTimeout(this._starter);
    clearInterval(this._timer);
    clearInterval(this._renderTimer);
    super.disconnectedCallback();
  }

  dispatchRefresh() {
    this.dispatchEvent(new CustomEvent(`refresh`));
  }

  updateInterval() {
    clearTimeout(this._starter);
    clearInterval(this._timer);
    const refreshInterval = this.attr(`refresh-interval-ms`);

    if (refreshInterval) {
      const lastRefreshed = moment(this.attr(`last-refresh-date`));
      const nextRefreshMs = refreshInterval - moment().diff(lastRefreshed, `milliseconds`);
      this._starter = setTimeout(() => {
        this.dispatchRefresh();
        this._timer = setInterval(() => this.dispatchRefresh(), refreshInterval);
      }, nextRefreshMs);
    }
  }
}

export const LastUpdatedEl = defineAndMakeJsxFactory(`mp-last-updated`, LastUpdated);
export const LastUpdatedReact = panel2react(`mp-last-updated`, LastUpdated);
